import { all, call, put, select, takeLatest } from "redux-saga/effects";
import queryApi from "../../utils/fetchApi";
import Urler from "../../utils/serviceUrl";
import {
  fetchNotificationsFailure,
  fetchNotificationsSuccess,
  markAsRead,
  markAsReadFailure,
  markAsReadSuccess,
} from "./notifications.actions";
import NotificationTypes from "./notifications.types";

const getToken = (state) => state.user.token;

export function* fetchNotifications() {
  try {
    const token = yield select(getToken);
    if (!token) {
      yield put(fetchNotificationsFailure("No auth token"));
      return;
    }

    const response = yield call(queryApi, {
      method: "GET",
      url: Urler("notifications/me"),
      bearer: token,
    });

    if (response.status === "success") {
      yield put(fetchNotificationsSuccess(response.data.notifications));
    } else {
      yield put(
        fetchNotificationsFailure(
          response.message || "Failed to fetch notifications",
        ),
      );
    }
  } catch (error) {
    console.error("[Notifications Saga] Fetch error:", error);
    yield put(fetchNotificationsFailure(error.message));
  }
}

export function* markNotificationsAsRead({ payload: notificationIds }) {
  try {
    const token = yield select(getToken);
    if (!token) {
      yield put(markAsReadFailure("No auth token"));
      return;
    }

    // Optimistically update the UI first
    yield put(markAsRead(notificationIds));

    const response = yield call(queryApi, {
      method: "POST",
      url: Urler("notifications/mark-read"),
      bearer: token,
      data: { notificationIds },
    });

    if (response.status === "success") {
      yield put(markAsReadSuccess(notificationIds));
    } else {
      console.error(
        "[Notifications] Failed to mark as read:",
        response.message,
      );
    }
  } catch (error) {
    console.error("[Notifications Saga] Mark as read error:", error);
    yield put(markAsReadFailure(error.message));
  }
}

export function* onFetchNotificationsStart() {
  yield takeLatest(
    NotificationTypes.FETCH_NOTIFICATIONS_START,
    fetchNotifications,
  );
}

export function* onMarkAsReadStart() {
  yield takeLatest(
    NotificationTypes.MARK_AS_READ_START,
    markNotificationsAsRead,
  );
}

export function* notificationsSagas() {
  yield all([call(onFetchNotificationsStart), call(onMarkAsReadStart)]);
}
